export default "__VITE_ASSET__CviMLAgS__"